export default __webpack_public_path__ + "static/life-grid-soft-blue-min-0430a778a136120afd818262946883ac.png";